import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isStatusChangeAlertOpened: false,
  isDeleteAlertOpened: false,
  isDeadlineChangeAlertOpened: false,
};

const OVSBotPipelineSlicer = createSlice({
  name: "ovsBotPipeline",
  initialState,
  reducers: {
    toggleStatusChangeAlert: (state, action) => {
      if (!action?.payload || typeof action?.payload !== "boolean")
        state.isStatusChangeAlertOpened = !state.isStatusChangeAlertOpened;
      else state.isStatusChangeAlertOpened = action.payload;
    },
    toggleDeleteAlert: (state, action) => {
      if (!action?.payload || typeof action?.payload !== "boolean")
        state.isDeleteAlertOpened = !state.isDeleteAlertOpened;
      else state.isDeleteAlertOpened = action.payload;
    },
    toggleDeadlineChangeAlert: (state, action) => {
      if (!action?.payload || typeof action?.payload !== "boolean")
        state.isDeadlineChangeAlertOpened = !state.isDeadlineChangeAlertOpened;
      else state.isDeadlineChangeAlertOpened = action.payload;
    },
  },
});

export const {
  toggleStatusChangeAlert,
  toggleDeleteAlert,
  toggleDeadlineChangeAlert,
} = OVSBotPipelineSlicer.actions;

export default OVSBotPipelineSlicer.reducer;
